// The guest map's reading of a room's stored geometry (CIN-15126). Pure, relative imports only, so `node --test`
// loads it without an install.

import { normalizeRoomGeometry } from '../room-3d/outline/room-geometry.ts';
import type { RoomGeometry } from '../room-3d/outline/types.ts';

/**
 * The geometry `GET /cinema-rooms/{id}` embeds under `cinemaRoomShape.geometry`, made safe to draw: the studio's
 * own tolerant reader validates it (a clockwise outline is turned around, anything that does not validate is
 * dropped), and a room with nothing left is `null`, the plain width x depth rectangle. The `invalid` flag the
 * reader raises for the studio's hint is not the guest's business and is never passed on.
 */
export function roomGeometryFromDto(raw: unknown): RoomGeometry | null {
    const { outline, levels, ceiling } = normalizeRoomGeometry(raw);
    if (!outline && levels.length === 0 && !ceiling) return null;
    return ceiling ? { version: 1, outline, levels, ceiling } : { version: 1, outline, levels };
}
